import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { HelpDocumentation } from '@/components/HelpDocumentation';
import { ArrowLeft } from 'lucide-react';

export default function Help() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="border-b border-border bg-card sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <h1 className="text-2xl font-bold text-foreground">Documentation</h1>
          <Button variant="outline" onClick={() => navigate('/')}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <HelpDocumentation />
      </div>
    </div>
  );
}
